<template>
    <footer class="footer">
        <div class="container-1">
            <div class="columns footer-main-columns">
                <div class="column">
                    <div class="columns">
                        <div class="column">
                            <div class="footer__link">
                                <router-link to="/advertisers">Advertisers</router-link>
                            </div>
                            <div v-if="isRussianIP" class="footer__link">
                                <a href="https://sk.ru" target="_blank">
                                    <img src="/images/skolkovo-color.svg" alt="Skolkovo logo" width="111" height="80">
                                </a>
                            </div>
                        </div>
                        <div class="column">
                            <div class="footer__link">
                                <router-link to="/technology">Technology</router-link>
                            </div>
                            <div class="footer__link">
                                <router-link to="/about">About</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="columns">
                        <div class="column">
                            <div class="footer__block">
                                <div class="footer__text">Drop us a line –</div>
                                <button type="button" class="footer__button"
                                        @click="$emit('contactShow', true)">
                                    Contact us
                                </button>
                            </div>
                            <div class="footer__block">
                                <div class="footer__text">Stay connected</div>
                                <a href="mailto:hi@sarafan.tech" class="footer__email">hi@sarafan.tech</a>
                                <a href="https://www.facebook.com/sarafan.tech" target="_blank"
                                   class="footer__icon facebook">
                                    <font-awesome-icon :icon="['fab', 'facebook-f']" />
                                </a>
                                <a href="https://www.linkedin.com/company/sarafantech" target="_blank"
                                   class="footer__icon linkedin">
                                    <font-awesome-icon :icon="['fab', 'linkedin']" />
                                </a>
                            </div>
                        </div>
                        <div class="column">
                            <div class="footer__block">
                                <div class="footer__text">New York</div>
                                <a href="tel:+13474804426" class="footer__phone">+1 347 480 44 26</a>
                            </div>
                            <div class="footer__block">
                                <div class="footer__text">Saint Petersburg</div>
                                <a href="tel:+78124247935" class="footer__phone">+7 812 424 79 35</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column footer__map">
                    <img src="/images/map.png" alt="" width="340" height="185">
                </div>
            </div>
            <div class="footer-bottom">
                <div class="footer-bottom__left">© 2019. All rights reserved</div>
                <div class="footer-bottom__right">
                    <router-link to="/privacy-policy">Privacy Policy</router-link>
                    <router-link to="/terms-of-use">Terms and Conditions</router-link>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState(['isRussianIP'])
        }
    }
</script>